import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Input } from "./index";

const formatChars = {
  // first digit of day
  d: "[0-3]",
  // first digit of month
  m: "[0-1]",
  // first digit of year
  y: "[1-2]",
  9: "[0-9]",
};

export const InputDate = forwardRef((props, ref) => {
  const { children, ...otherProps } = props;

  return (
    <Input
      ref={ref}
      placeholder=""
      formatChars={formatChars}
      // eslint-disable-next-line no-octal-escape
      pattern="^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$"
      mask={{
        mask: "d9.m9.y999",
        char: "_",
      }}
      {...otherProps}
    >
      {children}
    </Input>
  );
});

InputDate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

InputDate.displayName = "InputDate";

export default InputDate;
